import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

import { useFormatMessage } from '@/translations/useFormatMessage'

const Overlay = styled(Box)({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	minHeight: '100vh',
})

const Card = styled(Box)(({ theme }) => ({
	padding: theme.spacing(4),
	maxWidth: 480,
	width: '100%',
}))

export function OloNotAvailable() {
	const { t } = useFormatMessage()
	return (
		<Overlay role="main" aria-labelledby="olo-not-available-title">
			<Card>
				<Typography
					id="olo-not-available-title"
					component="h1"
					sx={{ typography: { xs: 'h3', sm: 'h2' } }}
				>
					{t('component:oloNotAvailable:heading')}
				</Typography>
				<Typography sx={{ typography: { xs: 'h5', sm: 'h4' } }} color="text.secondary">
					{t('component:oloNotAvailable:message')}
				</Typography>
			</Card>
		</Overlay>
	)
}
